<template>
    <div>
      <el-card>
        <!-- 功能 -->
        <div class="header-menu" style="margin-bottom: 40px;">
          <!-- class="demo-form-inline" -->
          <el-form :inline="true" label-width="100px">
            <el-form-item label="订单号(线下):">
              <el-input placeholder="请输入订单号" clearable v-model="input1"></el-input>
            </el-form-item>
            <el-form-item label="老师名称:">
              <el-input placeholder="请输入老师名称" clearable v-model="input2"></el-input>
            </el-form-item>
            <el-form-item label="手机号(家长):">
              <el-input placeholder="请输入家长电话" :maxlength="11" clearable v-model="input3"></el-input>
            </el-form-item>
            <el-form-item label="渠道:">
              <el-input placeholder="请输入家长电话" clearable v-model="input4"></el-input>
            </el-form-item>
            <el-form-item label="学生名称:">
              <el-input placeholder="请输入学生名称" v-model="input5" clearable></el-input>
            </el-form-item>
            <el-form-item label="科目:">
              <el-input placeholder="请输入科目" v-model="input6" clearable></el-input>
            </el-form-item>
            <el-form-item label="剩余次数:">
              <el-select filterable  clearable class="select" v-model="input7" placeholder="请选择剩余次数">
                <el-option v-for="item in sourcepeopleListtttt" :key="item.id" :value="item.id" :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间:">
               <el-date-picker value-format="yyyy-MM-dd" v-model="input8" type="daterange" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="退费时间:" >
               <el-date-picker value-format="yyyy-MM-dd" v-model="input9" type="daterange" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">  </el-date-picker>
            </el-form-item>
            <el-form-item label="订单状态:">
              <el-select class="select" filterable  clearable v-model="input10" placeholder="请选择" style="width:100%;">
                <el-option v-for="item in classTypessss" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>

  <!--
            <el-form-item label="学生状态" v-if="currentPath !== '/currentStudents'">
              <el-select class="select" filterable  clearable v-model="fromState.state" placeholder="请选择" style="width:100%;">
                <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跟进助理">
              <el-select class="select" filterable  clearable v-model="fromState.assistantId" placeholder="请选择跟进助理" style="width:100%;">
                <el-option v-for="item in Progressteacher" :key="item.id" :value="item.id" :label="item.realname">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所在地域:">
              <el-select v-model="fromState.regionName" clearable filterable placeholder="请选择所在地域">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
              </el-select>
            </el-form-item> -->
            <el-row>
              <!-- <el-col :span="18"></el-col> -->
              <el-col :span="12" :push="12" style="text-align: right;">
                <!-- <el-button @click="handleView" class="btns" size="small" icon="el-icon-view">查看沟通详情</el-button> -->
                <el-button  type="primary" @click="handleDownload" class="btns" size="small" icon="el-icon-download">导出</el-button>
                <el-button @click="handleClearList" class="btns" size="small" icon="el-icon-close">清除</el-button>
                <el-button type="primary" icon="el-icon-search" @click="searchStudent" size="small" class="btns" >搜索</el-button>
                <el-button type="primary" @click="addStudent" class="btns" size="small" icon="el-icon-plus">添加</el-button>
                <!-- <el-button type="primary" @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button> -->
              </el-col>
            </el-row>


          </el-form>



          <!-- <el-select v-model="value1" placeholder="年级" @change="queryClass" @clear="gradeListener" clearable>
            <el-option v-for="item in grade" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="value2" placeholder="班级" @change="queryStudentByClass" @clear="classListener" clearable>
            <el-option
              v-for="item in classNo"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
        </div>
        <!-- 查询学生列表-->
        <el-table :data="studentDatas" tooltip-effect	:stripe="true" height="700" :highlight-current-row="true" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
          <!-- <el-table-column label="序号" type="selection"></el-table-column> -->

          <template #empty>
            <el-empty style="position: absolute;top: 0;" v-if="studentDatas.length === 0" description="暂无数据"></el-empty>
          </template>


          <el-table-column prop="createDate" label="创建日期"  width="150px">
            <!-- <template slot-scope="scope"> -->
              <!-- <router-link :to="'/student-detail/' + scope.row.id" class="name-link" @click="highlightRow(scope.$index)">
                {{ scope.row.realname }}
              </router-link> -->
              <!-- <span style="color: #2784e5;" @click="highlightRow(scope.row.id,scope.$index)">  {{ scope.row.realname }}</span> -->
            <!-- </template> -->
          </el-table-column>
          <el-table-column prop="orderNumber" label="订单号(线下)" width="120px">
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.sex === 1">男</span>
              <span v-else-if="scope.row.sex === 2">女</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="wechatNumber" label="微信名称(销售)" width="150px"></el-table-column>
          <el-table-column prop="teacherName" label="老师姓名"></el-table-column>
          <el-table-column prop="phoneNumber" label="手机号(家长)" width="150px"></el-table-column>
          <el-table-column prop="channelName" label="渠道"></el-table-column>
          <el-table-column prop="studentName" label="学生名称"></el-table-column>
          <el-table-column prop="studentSex" label="性别"></el-table-column>
          <el-table-column prop="gradeNames" label="年级"></el-table-column>
          <el-table-column prop="classFee" label="课时费"></el-table-column>
          <el-table-column prop="categoryName" label="科目"></el-table-column>
          <el-table-column prop="oneMoney" label="行规单次金额" width="150px"></el-table-column>
          <el-table-column prop="totalDegree" label="总次数"></el-table-column>
          <el-table-column prop="paidTotal" label="已付次数"></el-table-column>
          <el-table-column prop="residueTotal" label="剩余次数"></el-table-column>
          <el-table-column prop="classTotal" label="上课次数"></el-table-column>
          <el-table-column prop="guildMoney" label="行规总额"></el-table-column>
          <el-table-column prop="paidMoney" label="已付总额"></el-table-column>
          <el-table-column prop="residueMoney" label="剩余总额"></el-table-column>
          <el-table-column prop="returnPremium" label="退费金额"></el-table-column>
          <el-table-column prop="returnPremiumDate" label="退费时间" width="120px"></el-table-column>
          <el-table-column label="订单状态" prop="orderType">
            <template v-slot="scope">
              <span v-if="scope.row.orderType === 1" style="color: #16e528;">已成单</span>
              <span v-if="scope.row.orderType === 2" style="color: #d9116c;">已退费</span>
              <span v-if="scope.row.orderType === 3" style="color: #f78723;">未定</span>
            </template>
          </el-table-column>

          <!-- <el-table-column label="学生类型">
            <template slot-scope="scope">
              <span v-if="scope.row.classType === 1">规划</span>
              <span v-if="scope.row.classType === 2">线下</span>
              <span v-if="scope.row.classType === 3">纯补课</span>
            </template>
          </el-table-column>
          <el-table-column label="学生状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 1">在读</span>
              <span v-if="scope.row.state === 2">结业</span>
              <span v-if="scope.row.state === 3">停课</span>
              <span v-if="scope.row.state === 4">流失</span>
            </template>
          </el-table-column>
          <el-table-column label="跟进老师">
            <template slot-scope="scope">
              <span v-for="(item, index)  in scope.row.progressTeacherName" :key="index">
                {{ item }} {{ (index == scope.row.progressTeacherName.length - 1) ? "" : "/" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="来源负责人">
            <template slot-scope="scope">
              <span v-for="(item) in sourcesPeople" :key="item.sourcepeopleId">
                <span v-if="scope.row.sourcepeopleId == item.sourcepeopleId">{{ item.sourcepeopleName }}</span>

              <span v-if="scope.row.sourceName != null && scope.row.sourceName != ''">{{ scope.row.sourceName }}</span>
            </template>
          </el-table-column> -->

          <el-table-column label="操作" width="100">
            <template v-slot="scope">
              <el-button type="text" @click="editById(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 弹出表单编辑学生 -->
        <el-dialog id="bb" title="编辑学生" :visible="visibleForm" :close-on-click-modal = false >
          <el-form ref="" label-position="left" label-width="80px">
            <el-form-item label="姓名">
              <el-input v-model="editFormData.realname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group class="sex" style="margin-left: -75%;" v-model="editFormData.sex">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="微信">
              <el-input v-model="editFormData.wechat" autocomplete="off"></el-input>
            </el-form-item> -->
            <el-form-item label="所在地域">
              <el-select v-model="editFormData.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="年级">
              <!-- <el-input v-model="editFormData.grade" autocomplete="off"></el-input> -->
              <el-cascader clearable style="width: 100%;" v-model="editFormData.grades" :options="gradeList"
                :props="props"></el-cascader>
            </el-form-item>
            <!-- <el-form-item label="家长电话">
              <el-input v-model="editFormData.telephone" autocomplete="off"></el-input>
            </el-form-item> -->
            <el-form-item label="家庭住址">
              <el-input v-model="editFormData.address" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="销售">
              <el-select class="select" filterable clearable v-model="editFormData.saleId" placeholder="请选择销售" style="width:100%;">
                <el-option v-for="source in salesName" :key="source.id" :value="source.id" :label="source.realname">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跟进助理">
              <el-select class="select"  filterable clearable v-model="editFormData.assistantId" placeholder="请选择跟进助理"
                style="width:100%;">
                <el-option v-for="source in Progressteacher" :key="source.id" :value="source.id" :label="source.realname">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="来源">
              <el-select class="select" filterable  clearable allow-create default-first-option v-model="editFormData.sourcepeopleId"
                placeholder="请选择来源负责人" style="width:100%;">
                <el-option v-for="source in sourcesPeople" :key="source.sourcepeopleId" :value="source.sourcepeopleId"
                  :label="source.sourcepeopleName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跟进老师">
              <el-select class="select" multiple filterable clearable v-model="editFormData.progressTeacherIds" placeholder="请选择跟进老师"
                style="width:100%;">
                <el-option v-for="source in Progressteacher1" :key="source.id" :value="source.id" :label="source.realname">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学生类型">
              <el-select class="select" filterable  clearable v-model="editFormData.classType" placeholder="请选择" style="width:100%;">
                <el-option v-for="item in classTypes" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="所在地域:">
              <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
              </el-select>
            </el-form-item> -->


            <el-form-item label="学生状态">
              <el-select class="select" filterable  clearable v-model="editFormData.state" placeholder="请选择" style="width:100%;">
                <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="预存课时">
              <el-input-number style="display: flex;width: 100%;" v-model="prestoreHoursNum"  :min="0" :max="999" ></el-input-number>
            </el-form-item>

            <el-form-item label="消除课时">
              <el-input-number :disabled="showEiet" style="display: flex;width: 100%;" v-model="eliminateHoursNum"  :min="0" :max="999" ></el-input-number>
            </el-form-item>
            <el-form-item label="所欠课时">
              <el-input-number :disabled="showEiet" style="display: flex;width: 100%;" v-model="arrearsHoursNum"  :min="0" :max="999" ></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="老师">
              <el-input
                placeholder="搜索老师"
                v-model="searchTeachers"
                @keyup.enter.native="handleSearch"
                clearable
              ></el-input>
            </el-form-item> -->
          </el-form>
          <div  class="dialog-footer">
            <el-button @click="cancelUpd">取 消</el-button>
            <el-button type="primary" @click="commit()">提 交</el-button>
          </div>
        </el-dialog>

        <!-- 弹出添加学生 -->
        <edit-students ref="editStudents" @refresh="refresh"></edit-students>
        <!-- 上一页，当前页，下一页 -->
        <!-- <div class="footer-button" v-if="pages < 1">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="fromState.pageNum" :page-size="fromState.pageSize" layout="total, prev, pager, next"
            :total="total"></el-pagination>
        </div> -->

        <div class="footer-button111" >
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :key="pageNumsss"
            :current-page="pageNumsss" :page-size="pageSizesss" layout="total, prev, pager, next"
            :total="totalss"  @update:current-page="updatePageNumsss"></el-pagination>
        </div>


      </el-card>

      <el-dialog append-to-body title="查看沟通详情" :visible="showView" :width="'60%'">

        <el-input v-model="input1" @input="handleInput"  placeholder="请输入学生姓名"></el-input>

        <el-table :data="tableData" border style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
                  <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="count" label="沟通次数" show-overflow-tooltip></el-table-column>
                  <el-table-column label="沟通详情" show-overflow-tooltip>
                    <template v-slot="scope">
                      <span @click="handleClickView(scope.row)" style="color:#428BCA;">详情</span>
                    </template>
                  </el-table-column>
          </el-table>

        <div class="footer-button" style="margin-top: 15px; text-align: center;">
          <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
            :current-page="pageNums" :page-size="pageSizes" layout="total, prev, pager, next"
            :total="totals"></el-pagination>
        </div>

        <div class="dialog-footer">
          <el-button @click="showView = false" size="small">关闭</el-button>
        </div>
      </el-dialog>



    </div>
  </template>

  <script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import EditStudents from "./EditStudents.vue";
  import { aW } from "@fullcalendar/core/internal-common";

  import loadingUtils from '../utils/loading'


  export default {
    name: "offlineCustomerFunding",
    components: { EditStudents },
    data () {
      return {

        pageNumsss:1,

        showView:false,
        input1:"",
        tableData:[ ],

        regionName:"北京",
        // optionsListt:[
        //   {name:"北京", id:'北京' },
        //   {name:"深圳", id:'深圳' },
        // ],
        showEiet:false,
        prestoreHoursNum: 0,
        eliminateHoursNum: 0,
        arrearsHoursNum: 0,
        gradeList: [],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
        studentData: [],
        classTypessss: [{ value: 1, label: '已成单' }, { value: 2, label: '已退费' }, { value: 3, label: '未定' }],
        classTypes: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
        searchTeachers: "",
        editFormData: {
          id: "",
          assistantId:'',
          classType: "",
          studentNo: "",
          username: "",
          realname: "",
          grades: [],
          classNo: "",
          telephone: "",
          genjinlaoshi: "",
          email: "",
          address: "",
          age: "",
          sex: "",
          sourceName: "",
          wechat: "",
          sourcepeopleId: "",
          saleId: "",
          genjinlaoshi: "",
          state: "",
          progressTeacherName: [],
          progressTeacherIds: [],
          createTime: null,
          regionName:'北京',
        },

        // progressTeacherName: [],
        Progressteacher: [],
        Progressteacher1: [],
        teacherData: [],
        sourcesPeople: [],
        salesName: [],
        keyword: "",
        fromState: {
          state:"",
          classType: '',
          realname: "",
          wechat: "",
          gradeList: [],
          telephone: "",
          address: "",
          progressTeacherName: "",
          saleName: "",
          sourcepeopleId: "",
          pageSize: 10,
          pageNum: 1,
          assistantId:'',
          regionName: '',
        },
        page: 1,
        pageSizesss: 10,
        pageNumsss: 1,
        pageSize: 10,
        total: 0,
        value1: "", // 年级
        value2: "", // 班级
        grade: [
          {
            value: "01",
            label: "高一"
          },
          {
            value: "02",
            label: "高二"
          },
          {
            value: "03",
            label: "高三"
          }
        ],
        sourcepeopleListtttt: [
          {
            value: "0",
            id: 0,
          },
          {
            value: "非0",
            id: 1,
          },

        ],
        sourcepeopleList: [
          {
            value: "bin",
            id: 1,
          },
          {
            value: "小慈",
            id: 2,
          },
          {
            value: "兰",
            id: 3,
          },
          {
            value: "小五",
            id: 4,
          },
          {
            value: "铁甲小宝",
            id: 5,
          },
        ],
        classNo: [
          {
            value: "",
            label: ""
          }
        ],
        currentPath: this.$route.path ,
        visibleForm: false,
        visibleDialog: false, //添加学生
        editFormRules: {
          username: [{ required: true, message: "请输入昵称", trigger: "blur" }],
          realname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
          sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
          grade: [{ required: true, message: "请输入年级", trigger: "blur" }],
          classNo: [{ required: true, message: "请输入班级", trigger: "blur" }],
          telephone: [
            { required: true, message: "请输入联系电话", trigger: "blur" }
          ],
          email: [{ required: true, message: "请输入邮件", trigger: "blur" }],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }],
          age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
          wechat: [{ required: true, message: "请输入微信", trigger: "blur" }]
        },

        pageNums:1,
        pageSizes:10,
        totals:0,

        optionsListt:[
          {dictValue:"北京", dictType:1 },
          {dictValue:"深圳", dictType:2 },
        ],

        pages:2,


        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: '',
        input8: [],
        input9: [],
        input10: '',
        totalss:0,
        studentDatas: [],
      };
    },

    watch:{
        '$route.path':function(newVal,oldVal){
              this.currentPath = newVal;
              this.getallStudentList()
          }
    },
    computed: {
      currentPage: {
        get() {
          return this.pageNumsss;
        },
        set(newValue) {

          this.pageNumsss = newValue;
        }
      }
    },

    created () {
      // this.getallStudentList()
      // this.allStudent();
      this.getDataSoursePeople();
      this.getTeacher()
      this.teacherSale()
      this.getGrade()


      this.allStudent();
    },

     mounted () {

      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
      })



      let pages = window.sessionStorage.getItem('pages')
      this.fromState.pageNum = Number(pages)

      this.pages = Number(pages)
      this.pageNumsss = Number(pages)


      this.$set(this.fromState,'pageNum',Number(pages))

      this.getallStudentList()



    },
    methods: {

      updatePageNumsss(newPage){
        this.pageNumsss = newPage;
      },

      handleClickView(itme){
        window.sessionStorage.setItem('telephoneCommunication','telephoneCommunication')
        this.$router.push({path:'/student-detail/' + itme.studentId, query:{ type:'telephoneCommunication' }})
      },

      handleView(){
        this.handleInput()
        this.showView = true
      },

      handleCurrentChanges(e){
        this.pageNums = e
        this.handleInput()
      },
      handleSizeChanges(e){
        this.pageSizes = e
        this.handleInput()
      },

      handleInput(){
        let data = {  pageNum: this.pageNums,  pageSize: this.pageSizes, studentName: this.input1,  }
        axios.post(`${apiBaseUrl}/communication/findStudentPage`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
            if(res.data.code === 200){
                if(res.data.data.records && res.data.data.records.length > 0){
                  this.tableData = res.data.data.records
                }else{
                  this.tableData = []
                }
                this.pageNums = res.data.data.current
                this.pageSizes = res.data.data.size
                this.totals = res.data.data.total
            }else{
              this.$message.error('error失败~')
            }
        })
      },

      count () {
        axios
          .get(`${apiBaseUrl}/student/calculate`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message)
              this.allStudent();
            } else {
              this.$message.error(res.data.message)
            }
          })
          .catch(error => {
            console.error(error);
          });
      },
      handleDownload () {
        loadingUtils.startLoading()
        const params = {
            orderNumber: this.input1,
            teacherName: this.input2,
            phoneNumber: this.input3,
            channelName: this.input4,
            studentName: this.input5,
            categoryName: this.input6,
            residueTotal: this.input7,
            createStartDate: this.input8.length > 0 ? this.input8[0] : '',
            createEndDate: this.input8.length > 0 ? this.input8[1] : '',
            returnPremiumStartDate: this.input9.length > 0 ? this.input9[0] : '',
            returnPremiumEndDate: this.input9.length > 0 ? this.input9[1] : '',
            orderType: this.input10,
            pageSize: this.pageSizesss,
            pageNum: this.pageNumsss,
        };
        axios
          .post(
            `${apiBaseUrl}/customerBelow/export`,
            params,
            { responseType: "blob",

            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')

          } } // 设置responseType为'blob'以接收二进制数据
          )
          .then((response) => {
            const blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }); // 从响应中获取Blob对象
            const downloadLink = document.createElement("a"); // 创建一个下载链接
            downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
            downloadLink.download = "学生.xlsx"; // 设置下载文件的文件名
            //

            downloadLink.click(); // 触发下载
            loadingUtils.endLoading()
          }).catch((error) => {
            this.$message.error(error)
            loadingUtils.endLoading()
          });
      },
      //获取年级
      getGrade () {
        axios
          .get(`${apiBaseUrl}/grade/getGrade`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(res => {
            if (res.data.data.length > 0) {
              this.gradeList = res.data.data;
            } else {
              this.$message({
                message: "获取年级列表失败",
                type: "error"
              });
            }
          })
          .catch(error => {

          });
      },
      refresh () {
        this.allStudent();
      },
      //客资来源负责人
      getDataSoursePeople () {
        axios
          .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then(response => {
            this.sourcesPeople = response.data.data.list;

          })
          .catch(error => {
            console.error(error);
          });
      },
      //销售
      teacherSale () {
        axios
          .get(`${apiBaseUrl}/teacher/teacherSale`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(response => {
            this.salesName = response.data.data
            // this.Progressteacher = response.data.data  //跟进老师
            //
            //
            this.Progressteacher1 = response.data.data; //跟进老师
            //
            //
            //
          })
          .catch(error => {
            console.error(error);
          });
      },
      //跟进老师
      getTeacher () {
           axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            // this.salesName = response.data.data
            // this.Progressteacher = response.data.data  //跟进老师
            //
            //
            this.Progressteacher = response.data.data; //跟进老师
            //
            //
            //
          })
          .catch(error => {
            console.error(error);
          });
      },

      //选中学员事件
      handleSelectionChange (arr) {
        const aa = [];
        for (let i = 0; i < arr.length; i++) {
          aa.push(arr[i].id);
        }
        this.teacherId = aa;
      },
      // 清空年级回到查询所有学生
      gradeListener () {
        this.allStudent();
        this.value2 = "";
      },

      // 清空班级回到查询所有班级
      classListener () { },

      // 查询班级信息
      queryClass () {
        this.$axios
          .get(`${apiBaseUrl}/class-grade/` + this.value1,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(res => {
            let ret = res.data.data;
            this.classNo.splice(0, this.classNo.length);
            this.value2 = "";
            ret.map(v => {
              this.classNo.push({
                value: v.classNo,
                label: v.className
              });
            });
          })
          .catch(error => { });
      },

      cancelUpd () {
        this.visibleForm = false;
        if (this.$refs.editFormData) {
          this.$nextTick(() => {
            this.$refs.editFormData.resetFields();
          });
        }
      },

      cancel () {
        if (this.$refs.editFormData) {
          this.$nextTick(() => {
            this.$refs.editFormData.resetFields();
          });
        }
        this.visibleDialog = false;
        this.$refs.editFormData.clearValidate();
      },
      // 根据班级查询学生信息
      queryStudentByClass () {
        this.$axios
          .get(`${apiBaseUrl}/student-class/` + this.fromState.pageNum + "/" + this.value2,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(res => {

            if (res.data.code == 0) {
              let ret = res.data.data;
              this.studentData = ret.records;
              this.total = ret.total;
            }
          })
          .catch(error => { });
      },

      inputListener () {
        this.allStudent();
      },

       async getallStudentList(){
        let data={
          state:'',
          classType:'',
          realname:'',
          wechat: "",
          gradeList: [],
          telephone: "",
          address: "",
          progressTeacherName: "",
          saleName: "",
          sourcepeopleId: "",
          pageSize: 10,
          pageNum:1,
          assistantId:'',
          regionName : localStorage.getItem('cityTepy')
        }

        if(this.currentPath === '/currentStudents'){
         data.state = 1
          data.isReading = 1
          }

          try {


              const res = await axios.post(`${apiBaseUrl}/student/students`, data, {
                  headers: {
                      'authorization': sessionStorage.getItem('tokenInfo')
                  }
              });

              // 更新学生数据和总数
              this.studentData = res.data.data.records;

              this.total = res.data.data.total;
              this.currentPage = res.data.data.current;

              window.sessionStorage.setItem('pages',1)

          } catch (err) {
              console.error("Error fetching student data: ", err);
          }

          // await axios
          // .post(`${apiBaseUrl}/student/students`, this.fromState,{
          //   headers:{
          //     'authorization': sessionStorage.getItem('tokenInfo')
          //   }
          // })
          // .then(res => {
          //   //
          //   this.studentData = res.data.data.records;
          //
          //   //
          //   //
          //   this.total = res.data.data.total;
          //   // this.pageSize = res.data.data.page;
          //   this.currentPage = res.data.data.current;

          // })
          // .catch(err => {
          //   //
          // });
        // }else{
        //  await axios
        //   .post(`${apiBaseUrl}/student/students`, this.fromState,{
        //     headers:{
        //       'authorization': sessionStorage.getItem('tokenInfo')
        //     }
        //   })
        //   .then(res => {
        //     //
        //     this.studentData = res.data.data.records;
        //
        //     //
        //     this.total = res.data.data.total;
        //     // this.pageSize = res.data.data.page;
        //     this.currentPage = res.data.data.current;

        //   })
        //   .catch(err => {
        //     //
        //   });
        // }
      },
      //查询所有学生
      allStudent () {
        // this.handleClearList()
        loadingUtils.startLoading()
        let data={
            orderNumber: this.input1,
            teacherName: this.input2,
            phoneNumber: this.input3,
            channelName: this.input4,
            studentName: this.input5,
            categoryName: this.input6,
            residueTotal: this.input7,
            createStartDate: this.input8.length > 0 ? this.input8[0] : '',
            createEndDate: this.input8.length > 0 ? this.input8[1] : '',
            returnPremiumStartDate: this.input9.length > 0 ? this.input9[0] : '',
            returnPremiumEndDate: this.input9.length > 0 ? this.input9[1] : '',
            orderType: this.input10,
            pageSize: this.pageSizesss,
            pageNum: this.pageNumsss,
        }

        // if(this.currentPath === '/currentStudents'){
        //  data.state = 1
        //   data.isReading = 1
        // }

        axios.post(`${apiBaseUrl}/customerBelow/findPage`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }) .then(res => {
          loadingUtils.endLoading()
          console.log(res)

           if(res.data.code === 200){
              if(res.data.data.records.length > 0){
                this.studentDatas = res.data.data.records
              }else{
                this.studentDatas = []
              }

              this.pageNumsss = res.data.data.current
              this.totalss = res.data.data.total

              this.$message.success('查询成功~')
           }else{
            this.$message.error('查询失败~')
           }

        }).catch(err => {
           this.$message.error(err)
           loadingUtils.endLoading()
        })

        // if(this.currentPath === '/currentStudents'){
        //    this.fromState.state = 1
        //    this.fromState.isReading = 1
        //    axios.post(`${apiBaseUrl}/student/students`, this.fromState,{
        //     headers:{
        //       'authorization': sessionStorage.getItem('tokenInfo')
        //     }
        //   })
        //   .then(res => {
        //     //
        //     this.studentData = res.data.data.records;

        //     //
        //     this.total = res.data.data.total;
        //     // this.pageSize = res.data.data.page;
        //     this.currentPage = res.data.data.current;

        //   })
        //   .catch(err => {
        //     //
        //   });
        // }else{
        //   axios.post(`${apiBaseUrl}/student/students`, this.fromState,{
        //     headers:{
        //       'authorization': sessionStorage.getItem('tokenInfo')
        //     }
        //   })
        //   .then(res => {
        //     //
        //     this.studentData = res.data.data.records;

        //     //
        //     this.total = res.data.data.total;
        //     // this.pageSize = res.data.data.page;
        //     this.currentPage = res.data.data.current;

        //   })
        //   .catch(err => {
        //     //
        //   });
        // }

      },
      handleClearList () {
        this.fromState = {
          realname: "",
          wechat: "",
          gradeList: [],
          classType: '',
          telephone: "",
          address: "",
          progressTeacherName: "",
          saleName: "",
          sourcepeopleId: "",
          pageSize: 10,
          pageNum: 1,
          assistantId:'',
          regionName:''
        }


        this.totalss = 0
        this.pageNumsss = 1
        this.pageSizesss = 10

        this.input1 = ''
        this.input2 = ''
        this.input3 = ''
        this.input4 = ''
        this.input5 = ''
        this.input6 = ''
        this.input7 = ''
        this.input8 = []
        this.input9 = []
        this.input10 = ''



        this.allStudent()
      },
      //关键字查询学生
      searchStudent () {
        // this.fromState.pageNum = 1
        // if (this.fromState.progressTeacherName != '' || this.fromState.saleName != '' || this.fromState.sourcepeopleId != '') {
        //   this.fromState.pageSize = 500
        // }
        this.allStudent()
        // this.$axios
        //   .get(`${apiBaseUrl}/student/search/` + this.keyword)
        //   .then(res => {
        //     let ret = res.data.data;
        //
        //     this.studentData = ret.records;
        //
        //     this.total = ret.total;
        //
        //     this.$message({ message: "查询成功", type: "success" });
        //   })
        //   .catch(error => {
        //     this.$message.error("查询失败");
        //   });
      },
      //点击添加按钮
      addStudent () {
        this.showEiet = false
        this.$nextTick(() => {
          this.$refs.editStudents.init('添加',null);
        });
        // this.visibleDialog = true;
        // //点击按钮表单清空
        // axios
        //   .post(`${apiBaseUrl}/teacher/query`, {
        //     page: "",
        //     limit: "",
        //     realname: this.searchTeachers
        //   })
        //   .then(res => {
        //     this.teacherData = res.data.data.list;
        //   })
        //   .catch(err => {
        //
        //   });
      },
      //按回车搜索姓名查询
      handleSearch () {
        if (this.searchTeachers) {
          //
          this.addStudent();
          // 清空搜索框
          // this.name = "";
        }
      },
      // //点击添加保存学生
      // saveAdd() {
      //   const data = {
      //     realname: this.editFormData.realname,
      //     age: this.editFormData.age,
      //     sex: this.editFormData.sex,
      //     telephone: this.editFormData.telephone,
      //     address: this.editFormData.address,
      //     grade: this.editFormData.grade,
      //     wechat: this.editFormData.wechat,
      //     sourcepeopleId: this.editFormData.sourcepeopleId,
      //     progressTeacherIds: this.editFormData.progressTeacherIds,
      //     saleId: this.editFormData.saleId
      //   };

      //   axios
      //     .post(`${apiBaseUrl}/student/addstudent`, data)
      //     .then(res => {
      //       //
      //       if (res.data.code == 200) {
      //         //成功
      //         this.$message({
      //           message: res.data.message,
      //           type: "success"
      //         });
      //        this.visibleDialog = false;

      //         this.allStudent();
      //       } else {
      //         //失败
      //         this.$message({
      //           message: res.data.message,
      //           type: "error"
      //         });
      //       }
      //     })
      //     .catch(err => {
      //       console.error(err);
      //     });
      // },

      // saveAdd(formName) {
      //   this.$refs['editFormData'].validate(valid => {
      //     if (valid) {
      //       const data = {
      //         realname: this.editFormData.realname,
      //         age: this.editFormData.age,
      //         sex: this.editFormData.sex,
      //         telephone: this.editFormData.telephone,
      //         classNo: this.editFormData.classNo,
      //         address: this.editFormData.address,
      //         grade: this.editFormData.grade,
      //         // teacherId: this.teacherId.join(",")
      //       };

      //       axios
      //         .post(`${apiBaseUrl}/student/addstudent`, data)
      //         .then(res => {
      //           //
      //           if (res.data.code == 200) {
      //             //成功
      //             this.$message({
      //               message: res.data.message,
      //               type: "success"
      //             });
      //             //如表单还有数据没有清空掉就给默认值
      //             // this.$refs.ruleForm.resetFields();
      //             // this.listdate();
      //             this.visibleDialog = false;
      //             this.allStudent();
      //           } else {
      //             //失败
      //             this.$message({
      //               message: res.data.message,
      //               type: "error"
      //             });
      //           }
      //         })
      //         .catch(err => {
      //           console.error(err);
      //         });
      //     } else {
      //       return false;
      //     }
      //   });
      // },

      //根据id删除学生
      deleteById (index, row) {
        this.$confirm('此操作将删除该该学生, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
                this.deleteStudentById(row.id);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },

      deleteStudentById (id) {
        this.$axios
          .delete(`${apiBaseUrl}/student/delete/` + id,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(res => {
            this.$message({ message: "删除成功", type: "success" });
            this.allStudent();
          })
          .catch(error => {
            this.$message.error("删除失败");
          });
      },

      // 点击编辑学生回显数据
      editById (index, row) {

        this.showEiet = false
        this.$nextTick(() => {
          this.$refs.editStudents.init('编辑',row);
        });





        // this.showEiet = true
        // let modifyId = row.id;
        // this.$axios
        //   .get(`${apiBaseUrl}/student/` + modifyId,{
        //     headers:{
        //       'authorization': sessionStorage.getItem('tokenInfo')
        //     }
        //   })
        //   .then(res => {

        //     // this.regionName = res.data.data.regionName ? res.data.data.regionName : '北京'

        //     this.editFormData = res.data.data;
        //     //
        //     this.editFormData.grades = JSON.parse(res.data.data.grade)
        //     this.editFormData.sex = res.data.data.sex + "";

        //     // this.editFormData.regionName = res.data.data.regionName  ? res.data.data.regionName : '北京'
        //     this.editFormData.regionName = Number(res.data.data.regionName)
        //     //

        //     if(res.data.data.assistantId){
        //         this.editFormData.assistantId = res.data.data.assistantId ? res.data.data.assistantId : null
        //     }


        //     if (res.data.data.sourcepeopleId == null) {
        //       this.editFormData.sourcepeopleId = res.data.data.sourceName
        //     } else {
        //       this.editFormData.sourcepeopleId = res.data.data.sourcepeopleId
        //     }
        //   })
        //   .catch(error => { });
        // this.editFormData = row;
        // this.prestoreHoursNum = row.prestore,
        // this.eliminateHoursNum = row.eliminate,
        // this.arrearsHoursNum = row.arrears,
        // this.visibleForm = true;
      },

      //编辑提交
      commit () {
        //
        this.editFormData.sex = this.editFormData.sex;
        if (typeof this.editFormData.sourcepeopleId === 'number') {
          this.editFormData.sourcepeopleId = this.editFormData.sourcepeopleId
          this.editFormData.sourceName = ""
        } else {
          this.editFormData.sourceName = this.editFormData.sourcepeopleId
          this.editFormData.sourcepeopleId = null
        }

        this.modifyStudent(this.editFormData);
      },

      //更新学生
      modifyStudent (modifyData) {
        modifyData.createTime = null;
        modifyData.prestore = this.prestoreHoursNum
        modifyData.eliminate = this.eliminateHoursNum
        modifyData.arrears = this.arrearsHoursNum

        // modifyData.regionName = this.regionName

        this.$axios
          .post(
            `${apiBaseUrl}/student/modify/` + this.editFormData.id,
            modifyData,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }
          )
          .then(res => {
            //
            if(res.data.code === 200){
              this.$message({ message: res.data.message, type: "success" });
              this.allStudent();
              this.visibleForm = false;
            }else{
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .catch(error => {
            this.$message.error("更新失败");
          });
      },

      handleSizeChange (val) {

        this.pageSizesss = val;
        this.allStudent();
      },

      handleCurrentChange (v) {

        this.pageNumsss = v;
        this.allStudent();
      },
      //点击姓名出现弹层
      highlightRow (id,index) {
        window.sessionStorage.setItem('telephoneCommunication','classPlan')

        this.$router.push({path:`/student-detail/${id}/${this.fromState.pageNum}`, })


        // 清除之前的高亮状态
        if (this.highlightedIndex !== -1) {
          // 假设表格组件提供了清除高亮的方法，如 clearHighlight
          // this.$refs.table.clearHighlight();
        }
        // 设置当前行为高亮状态
        // 假设表格组件提供了设置高亮的方法，如 highlightRow
        // this.$refs.table.highlightRow(index);
        this.highlightedIndex = index;

      }
    }

  };
  </script>

  <style scoped>
  .el-input-group {
    width: 40%;
  }

  .header-menu {
    margin-bottom: 5px;
    padding: 0;
    text-align: left;
    margin-bottom: 5px;
  }

  .footer-button {
    margin-top: 10px;
  }

  /* 兼容移动端 */
  @media screen and (max-width: 750px) {
    .dashboard-container {
      /* overflow: auto; */
      width: 1430px;
    }

    /* 兼容移动端 */
    #bb>>>.el-dialog {
      width: 70%;
    }

    .el-input-group {
      width: 60%;
    }

    .sex {
      margin-left: -15% !important;
    }
  }
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }




  </style>



// WEBPACK FOOTER //
// src/CustomerFundingAll/offlineCustomerFunding.vue